<template>
    <div v-if="this.case_id != null && this.case_info != null && this.case_info.consultations[0].status != 'submitted'">
        <v-btn class="mow-button" @click="toogleOptions()" v-if="!this.showOptions">
            Prefill Options <v-icon icon>mdi-chevron-double-left</v-icon>
        </v-btn>
        <v-slide-x-transition>
            <v-row fluid class="fill-height mow-container" v-if="this.showOptions">
                <v-col cols="8"  @click="toogleOptions()"></v-col>
                <v-col cols="4" class="mow-options-container" style="z-index: 3;">
                    <h4 class="mow-header primary--text">Med-Ops RDP Auto-fill Template</h4>
                    <v-row class="mow-options">
                        <v-radio-group v-model="type" style="margin-top: 0px;">
                            <div class="mow-option" v-for="(option, index) in templateOptions" v-bind:key="index"> 
                                <div class="d-flex">
                                    <v-radio :value="index"></v-radio>
                                    <span class="mow-option-label" :class="{'primary--text': type==index}">{{ option.option.label }}</span>
                                </div>
                                <span class="mow-option-sub-label">{{ option.option.sub_label }}</span>
                            </div>
                        </v-radio-group>
                    </v-row>
                    <v-row class="justify-center">
                        <v-btn rounded class="primary mr-3" @click="applyTemplate()">Apply</v-btn>
                        <v-btn rounded @click="toogleOptions()">Close</v-btn>
                    </v-row>
                    <!-- <hr style="margin: 15px 0;" /> -->
                    <!-- <v-row>
                        <v-col>
                            <h4 class="mow-header primary--text">History</h4>
                            <ul class="mow-ul-history">
                                <li v-for="(history, index) in medops_history" :key="index" @click="openHistory(index)">
                                    <strong class="d-block">{{ history.time }}</strong>
                                    <small>{{ history.label }}</small>
                                </li>
                            </ul>
                        </v-col>
                    </v-row> -->
                </v-col>
            </v-row>
        </v-slide-x-transition>

        <v-dialog v-model="showSuccess" max-width="400px" persistent>
            <v-card class="px-5 py-10" rounded="lg">
                <v-card-text>
                    <slot>
                        <h2 class="text-center">{{ templateName }}</h2>
                    </slot>
                </v-card-text>
                <v-card-actions class="d-flex justify-center">
                    <v-btn rounded depressed color="primary" width="100px" class="mx-3" @click="closeDialog()">
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showHistory" max-width="800px" persistent>
            <v-card class="px-5 py-10" rounded="lg">
                <v-card-text>
                    <slot>
                        <h2 class="text-center">Apply History</h2>
                        <hr class="mt-2 mb-2">
                        <strong class="d-block mb-3">Do really want to apply the history on {{ selectedHistory.time }}?</strong>
                        <v-table>
                            <tbody>
                                <tr>
                                    <td>Case Category</td>
                                    <td>{{ selectedHistory.case_category }}</td>
                                </tr>
                                <tr>
                                    <td>Sub Case Category</td>
                                    <td>{{ selectedHistory.case_sub_category }}</td>
                                </tr>
                                <tr v-if="selectedHistory.hasOwnProperty('diagnoses')">
                                    <td>Diagnoses</td>
                                    <td>
                                        {{ selectedHistory.diagnoses.length > 0 ? selectedHistory.diagnoses[0].code : '' }}<br/>
                                        {{ selectedHistory.diagnoses.length > 0 ? selectedHistory.diagnoses[0].description : '' }}<br/>
                                        {{ selectedHistory.diagnoses.length > 0 ? selectedHistory.diagnoses[0].impression : '' }}<br/>
                                    </td>
                                </tr>
                                <tr v-if="selectedHistory.hasOwnProperty('recommendations')">
                                    <td>Recommendations</td>
                                    <td>
                                        {{ selectedHistory.recommendations.length > 0 ? selectedHistory.recommendations[0].point_of_care : '' }} <br/>
                                        {{ selectedHistory.recommendations.length > 0 ? selectedHistory.recommendations[0].time_to_treat : '' }} <br/>
                                        {{ selectedHistory.recommendations.length > 0 ? selectedHistory.recommendations[0].recommended_action : ''}} <br/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Vices</td>
                                    <td>{{ selectedHistory.vices }}</td>
                                </tr>
                                <tr>
                                    <td>Dietary</td>
                                    <td>{{ selectedHistory.dietary }}</td>
                                </tr>
                                <tr>
                                    <td>Immunization</td>
                                    <td>{{ selectedHistory.immunization }}</td>
                                </tr>
                                <tr>
                                    <td>Illnesses</td>
                                    <td>{{ selectedHistory.illnesses }}</td>
                                </tr>
                                <tr>
                                    <td>Hospitalizations</td>
                                    <td>{{ selectedHistory.hospitalizations }}</td>
                                </tr>
                                <tr>
                                    <td>Operations</td>
                                    <td>{{ selectedHistory.operations }}</td>
                                </tr>
                                <tr v-if="selectedHistory.hasOwnProperty('notes')">
                                    <td>Notes</td>
                                    <td>
                                        <p v-for="(items, index) in selectedHistory.notes" :key="index">
                                            {{ JSON.stringify(items) }}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Documents</td>
                                    <td>
                                        Care Plan: {{ selectedHistory.plan ? 'Yes' : 'No' }} <br/>
                                        Prescription: {{ selectedHistory.prescription ? 'Yes' : 'No' }} <br/>
                                        Medical Certificate: {{ selectedHistory.certificate ? 'Yes' : 'No' }} <br/>
                                        Laboratory: {{ selectedHistory.laboratory ? 'Yes' : 'No' }} <br/>
                                    </td>
                                </tr>
                            </tbody>
                        </v-table>
                    </slot>
                </v-card-text>
                <v-card-actions class="d-flex justify-center">
                    <v-btn rounded depressed color="primary" width="100px" class="mx-3" @click="applyHistory()">
                        Apply
                    </v-btn>
                    <v-btn rounded depressed width="100px" class="mx-3" @click="closeHistory()">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import { GET_TEMPLATES } from './typeDefs/MedOpsTemplate';

export default {
    name: 'MedOpsPrefill',
    data: () => ({
        showOptions: false,
        type: '',
        showSuccess: false,
        templateName: '',
        templateOptions: {},
        validOptionsTitle: [],
        medops_history: [],
        showHistory: false,
        selectedHistory: {}
    }),

    computed: {
        case_info() { return this.$store.getters['cases/case'] },
        case_id() { return this.$store.getters['cases/case_id'] },

        terminator: {
            get() { return this.$store.getters['cases/terminator'] },
            set(val) { this.$store.commit('cases/setTerminator', val) }
        },

        patient () { return this.$store.getters['patient/patient'] },

        //Case Category
        case_category: {
            get() { return this.$store.getters['cases/case_category'] },
            set(val) { this.$store.commit('cases/updateCategory', val) }
        },

        case_sub_category: {
            get() { return this.$store.getters['cases/case_sub_category'] },
            set(val) { this.$store.commit('cases/updateCaseSubCategory', val) }
        },
        //Case Category

        //Diagnosis
        codes() {
            return this.$store.getters['diagnosis/codes'];
        },

        diagnoses: {
            get() { return this.$store.getters['diagnosis/diagnoses'] },
            set() { this.$store.getters['diagnosis/diagnoses'] }
        },

        code: {
            get() { return this.$store.getters['diagnosis/code'] },
            set(val) { this.$store.commit('diagnosis/updateCode', val) }
        },
        
        description: {
            get() { return this.$store.getters['diagnosis/description'] },
            set(val) { this.$store.commit('diagnosis/updateDescription', val) }
        },
        
        impression: {
            get() { return this.$store.getters['diagnosis/impression'] },
            set(val) { this.$store.commit('diagnosis/updateImpression', val) }
        },
        //Diagnosis

        //Recommendations
        recommendations: {
            get() { return this.$store.getters['recommendation/recommendations'] },
            set() { this.$store.getters['recommendation/recommendations'] }
        },

        point_of_care: {
            get() { return this.$store.getters['recommendation/point_of_care'] },
            set(val) { this.$store.commit('recommendation/updatePointOfCare', val) }
        },

        time_to_treat: {
            get() { return this.$store.getters['recommendation/time_to_treat'] },
            set(val) { this.$store.commit('recommendation/updateTimeToTreat', val) }
        },

        recommended_action: {
            get() { return this.$store.getters['recommendation/recommended_action'] },
            set(val) { this.$store.commit('recommendation/updateAction', val) }
        },
        //Recommendations

        //Notes
        notes: {
            get() { return this.$store.getters['cases/notes'] },
            set() { this.$store.getters['cases/updatenotes'] }
        },

        title: {
            get() { return this.$store.getters['cases/title'] },
            set(val) { this.$store.commit('cases/updateTitle', val) }
        },
        
        note: {
            get() { return this.$store.getters['cases/note'] },
            set(val) { this.$store.commit('cases/updateNote', val) }
        },
        //Notes

        //Documents
        plan: {
            get() { return this.$store.getters['request/plan'] },
            set(val) { this.$store.commit('request/setPlanValue', val) }
        },

        prescription: {
            get() { return this.$store.getters['request/prescription'] },
            set(val) { this.$store.commit('request/setPrescriptionValue', val) }
        },

        certificate: {
            get() { return this.$store.getters['request/certificate'] },
            set(val) { this.$store.commit('request/setCertificate', val) }
        },

        laboratory: {
            get() { return this.$store.getters['request/laboratory'] },
            set(val) { this.$store.commit('request/setLaboratory', val) }
        },
        //Documents

        //Patient Medical History
        vices: {
            get() { return this.$store.getters['patient/vices'] },
            set(val) { this.$store.commit('patient/updateVices', val) }
        },

        dietary: {
            get() { return this.$store.getters['patient/dietary'] },
            set(val) { this.$store.commit('patient/updateDietary', val) }
        },

        immunization: {
            get() { return this.$store.getters['patient/immunization'] },
            set(val) { this.$store.commit('patient/updateImmunization', val) }
        },

        illnesses: {
            get() { return this.$store.getters['patient/illnesses'] },
            set(val) { this.$store.commit('patient/updateIllnesses', val) }
        },

        hospitalizations: {
            get() { return this.$store.getters['patient/hospitalizations'] },
            set(val) { this.$store.commit('patient/updateHospitalizations', val) }
        },

        operations: {
            get() { return this.$store.getters['patient/operations'] },
            set(val) { this.$store.commit('patient/updateOperations', val) }
        },
        //Patient Medical History          
    },

    mounted() {
        this.templateOptions = GET_TEMPLATES;
        for (let ii in this.templateOptions) {
            this.validOptionsTitle.push(this.templateOptions[ii].notes.title);
        }
    },

    methods: {

        applyHistory () {
            this.templateName = `The data from ${this.selectedHistory.time} has been restored successfully.`;//this.selectedHistory.label + ' on ' + this.selectedHistory.time;

            console.log('history:', this.selectedHistory);

            //Case Category
            this.case_category = this.selectedHistory.case_category;
            this.case_sub_category = this.selectedHistory.case_sub_category;
            //Case Category

            this.terminator = this.selectedHistory.terminator;

            //PPMH
            this.vices = this.selectedHistory.vices;
            this.dietary = this.selectedHistory.dietary;
            this.immunization = this.selectedHistory.immunization;
            this.illnesses = this.selectedHistory.illnesses;
            this.hospitalizations = this.selectedHistory.hospitalizations;
            this.operations = this.selectedHistory.operations;
            //PPMH

            //diagnosis
            if (this.selectedHistory.diagnoses != undefined) {
                
                this.$store.commit('diagnosis/setActive', 0);
                this.$store.commit('diagnosis/remove');

                if (this.selectedHistory.diagnoses.length > 0) {
                    this.code = this.selectedHistory.diagnoses[0].code;
                    this.description = this.selectedHistory.diagnoses[0].description;
                    this.impression = this.selectedHistory.diagnoses[0].impression;
                    this.$store.commit('diagnosis/add');
                }
            }
            //diagnosis

            //recommendation
            if (this.selectedHistory.recommendations != undefined) {
                if (this.selectedHistory.recommendations.length > 0) {
                    this.point_of_care = this.selectedHistory.recommendations[0].point_of_care;
                    this.time_to_treat = this.selectedHistory.recommendations[0].time_to_treat;
                    this.recommended_action = this.selectedHistory.recommendations[0].action;
                    this.$store.commit('recommendation/edit', 0);
                } else if (this.recommendations.length > 0) {
                    this.$store.commit('recommendation/setActive', 0);
                    this.$store.commit('recommendation/remove');
                }
            }
            //recommendation

            //notes
            let iNote = this.notes.length;
            for (let ii = 1; ii <= iNote; ii++) {
                console.log(ii);
                this.$store.commit('cases/setActiveNote', 0);
                this.$store.commit('cases/removeNote');
            }

            for (let iii = 1; iii <= this.selectedHistory.notes.length; iii++) {
                let aNote = this.selectedHistory.notes[iii-1];
                this.title = aNote.title;
                this.note = aNote.note;
                this.$store.commit('cases/addNote');
                this.$store.commit('cases/clearNote');
            }
            //notes

            //documents
            this.plan = this.selectedHistory.plan;
            this.prescription = this.selectedHistory.prescription;
            this.certificate = this.selectedHistory.certificate;
            this.laboratory = this.selectedHistory.laboratory;
            //documents
            this.closeHistory();
            this.showSuccess = true;
        },

        closeHistory () {
            this.selectedHistory = {};
            this.showHistory = false;
        },

        openHistory(index) {
            let history = this.medops_history[index];
            console.log(history);
            this.selectedHistory = history;
            this.showHistory = true;
        },

        toogleOptions() {
            this.type = '';

            console.log('Case Info:', this.case_info);

            this.showOptions = !this.showOptions;
            if (this.showOptions) {
                let history = localStorage.getItem(this.case_id+'_history');
                if (history != null) {
                    this.medops_history = JSON.parse(history);
                } else {
                    this.medops_history = [];
                }
            }
        },

        addHistory () {
            let selectedTemplate = this.templateOptions[this.type];
            let historyData = {
                case_category: this.case_category,
                case_sub_category: this.case_sub_category,
                diagnoses: this.diagnoses,
                recommendations: this.recommendations,
                notes: this.notes,
                vices: this.vices,
                dietary: this.dietary,
                immunization: this.immunization,
                illnesses: this.illnesses,
                hospitalizations: this.hospitalizations,
                operations: this.operation,
                plan: this.plan,
                prescription: this.prescription,
                certificate: this.certificate,
                laboratory: this.laboratory,
                time: new Date().toLocaleString(),
                label: 'Restore previous data prior to applying the '+selectedTemplate.name,
                type: this.type,
                terminator: this.terminator
            }

            let history = localStorage.getItem(this.case_id+'_history');
            if (history != null) {
                history = JSON.parse(history)
            } else {
                history = [];
            }
            history.push(historyData);
            localStorage.setItem(this.case_id+'_history', JSON.stringify(history));
            
        },

        applyTemplate () {
            let selectedTemplate = this.templateOptions[this.type];
            this.templateName = `The ${selectedTemplate.name} has been successfully applied`;

            this.addHistory();

            //Case Category
            let age = this.patient.age.toString().replace(/\D/g, '');
            if (age >= 18) {
                this.case_category = selectedTemplate.case_category[0].value;
                this.case_sub_category = '';
            } else {
                this.case_category = selectedTemplate.case_category[1].value;
                this.case_sub_category = selectedTemplate.case_category[1].sub;
            }
            //Case Category

            this.terminator = selectedTemplate.option.value;

            //PPMH
            this.vices = this.vices == '' ? '-' : this.vices;
            this.dietary = this.dietary == '' ? '-' : this.dietary;
            this.immunization = this.immunization == '' ? '-' : this.immunization;
            this.illnesses = this.illnesses == '' ? '-' : this.illnesses;
            this.hospitalizations = this.hospitalizations == '' ? '-' : this.hospitalizations;
            this.operations = this.operations == '' ? '-' : this.operations;
            //PPMH

            //diagnosis
            if (this.diagnoses.length > 0) {
                console.log('lenght:', this.diagnoses.length);
                this.$store.commit('diagnosis/setActive', 0);
                this.$store.commit('diagnosis/remove');
            }
            
            this.code = selectedTemplate.diagnosis.code;
            this.description = selectedTemplate.diagnosis.description;
            this.impression = selectedTemplate.diagnosis.impression;
            this.$store.commit('diagnosis/add');
            this.$store.commit('diagnosis/clear');
            //diagnosis

            //recommendation
            if (this.recommendations.length > 0) {
                this.$store.commit('recommendation/setActive', 0);
                this.$store.commit('recommendation/remove');
            }
            this.point_of_care = selectedTemplate.recommendation.point_of_care;
            this.time_to_treat = selectedTemplate.recommendation.time_to_treat;
            this.recommended_action = selectedTemplate.recommendation.action;
            this.$store.commit('recommendation/add');
            this.$store.commit('recommendation/clear');
            //recommendation

            //notes
            let nIndex = -1;
            for (let ii in this.notes) {
                if ( this.validOptionsTitle.indexOf(this.notes[ii].title) >= 0 ) {
                    nIndex = ii;
                    this.$store.commit('cases/setActiveNote', ii);
                }
            }

            this.title = selectedTemplate.notes.title;
            this.note = selectedTemplate.notes.note;

            if (nIndex >= 0) {
                console.log('Edit Note');
                this.$store.commit('cases/editNote');
            } else {
                this.$store.commit('cases/addNote');
            }
            this.$store.commit('cases/clearNote');
            //notes

            //documents
            this.plan = (selectedTemplate.documents.indexOf('plan') >= 0) ? true : false;
            this.prescription = (selectedTemplate.documents.indexOf('prescription') >= 0) ? true : false;
            this.certificate = (selectedTemplate.documents.indexOf('certificate') >= 0) ? true : false;
            this.laboratory = (selectedTemplate.documents.indexOf('laboratory') >= 0) ? true : false;
            //documents

            this.showSuccess = true;
        },

        closeDialog () {
            this.showSuccess = false;
            this.toogleOptions();
        }
    }
}
</script>

<style scoped>

    .mow-ul-history {
        margin: 15px;
    }

    .mow-ul-history li {
        padding: 5px 15px;
        cursor: pointer;
    }

    .mow-ul-history li:hover {
        background: #e7e7e7;
        color: #258bf5;
    }

    .mow-header {
        margin: 15px 15px 0 15px;
        font-size: 20px;
    }
    .mow-container {
        position: absolute;
        z-index: 2;
        background: rgba(0, 0, 0, 0.2);
        width: 100%;
        top: 0;
        left: 10px;
        justify-content: end;
        overflow-y: scroll;
    }

    .mow-options-container {
        background: #fff;
        border-top: 1px solid #b3b3b3;
        position: relative;
    }

    .mow-options {
        padding: 0 35px;
    }

    .mow-option {
        margin: 15px 0;
    }

    .mow-option span.mow-option-label {
        font-size: 18px;
        font-weight: bolder;
    }

    .mow-option span.mow-option-sub-label {
        font-size: 12px;
        margin-left: 30px;
        display: block;
    }

    .mow-button {
        position: absolute;
        z-index: 3006;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
        right: 0;
        top: 130px;
    }

    .mow-button-close {
        text-decoration: none;
        color: inherit;
        text-align: right;
        display: flow-root;
        margin-top: 15px;
        margin-bottom: 15px;
    }
</style>